import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { GraphQLAPI } from "@examspark/api";

/**
 * This is just a wrapper to help with type inference.
 * @param options The query options
 * @returns The provided query options
 */
export const createQuery = <
  TQueryFnData,
  TError,
  TData,
  TKeys extends QueryKey,
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TKeys>,
): UseQueryOptions<TQueryFnData, TError, TData, TKeys> => options;

export const getReactQueryClientParams = (chatty?: boolean) => ({
  ...(chatty
    ? {
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
          },
        },
      }
    : {
        defaultOptions: {
          queries: {
            retry: 3,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 5,
          },
        },
      }),
});

/**
 * @deprecated Use GraphQLAPI.query.
 */
export const gqlQuery = GraphQLAPI.query;
